module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f8d6d074eb4dcbdc95cf9344779f2bf5.png";